import React from 'react';

/**
 * Small info banner shown above text fields that support markdown bold + auto-links.
 * Tells hosts they can write **text** to make it bold, and any URL becomes a link.
 */
export default function MarkdownHint() {
  return (
    <div className="mb-2 flex items-start gap-2 text-xs bg-blue-50 border border-blue-200 rounded-md p-2 text-blue-900" data-testid="markdown-hint">
      <span className="font-bold text-base leading-none">B</span>
      <div>
        Tip: text v <code className="bg-white px-1 py-0.5 rounded border border-blue-300 font-mono">**dvojhvězdičkách**</code> bude <strong>tučně</strong>.
        Vložený odkaz (např. <code className="bg-white px-1 py-0.5 rounded border border-blue-300 font-mono">https://…</code>) se zobrazí jako klikací.
      </div>
    </div>
  );
}
